import { useCallback, useState } from "react";

export const useClickAnimation = <T>(
  injectHandleEvent?: (event: T) => void,
): {
  clicked: boolean;
  onClick: (event: T) => void;
  onAnimationEnd: (event: React.SyntheticEvent<HTMLElement>) => void;
} => {
  const [clicked, setClicked] = useState(false);

  const onClick = useCallback(
    (event: T) => {
      setClicked(true);
      if (injectHandleEvent !== undefined) {
        injectHandleEvent(event);
      }
    },
    [injectHandleEvent],
  );

  const onAnimationEnd = useCallback(() => {
    setClicked(false);
  }, []);

  return { clicked, onClick, onAnimationEnd };
};
